module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_Wood_MockedUp.65a3ce00.jpg";